/* eslint-disable camelcase */
/* eslint-disable no-restricted-globals */

import React, { useState, useEffect } from 'react';
import { Dropdown, ListGroup, Badge } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import user from './../../../assets/images/user.png';
import ContactSupport from '../../../components/shared/ContactSupport';
import { AuthActions } from '../../../features/Auth/AuthSlice';
import { SocketActions } from '../../../features/Socket/SocketSlice';
import { initSocket } from '../../../Services/Socket';
import _ from 'lodash';

const NavRight = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { rtlLayout } = useSelector((state) => state.config);

  const { isAuthenticated, username } = useSelector((state) => state.auth);
  const { notifications, isSocketConnected } = useSelector((state) => state.socket);
  const { isFeedBackLoopEnabled } = useSelector((state) => state.general);
  const [isPopupOpen, setPopupOpen] = useState(false);
  const [unreadNotification, setUnreadNotification] = useState(false);
  const [isFullScreen, SetFullScreen] = useState(() => {
    return document.fullscreenElement;
  });

  const popupOpen = () => {
    setPopupOpen(true);
  };

  const handleLogout = async () => {
    try {
      await dispatch(AuthActions.logout());
      navigate('/login');
    } catch (err) {
      console.error(err);
    }
  };

  function toggleFullScreen() {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen();
      SetFullScreen(true);
    } else if (document.exitFullscreen) {
      document.exitFullscreen();
      SetFullScreen(false);
    }
  }

  useEffect(() => {
    const connectSocket = async () => {
      if (!isFeedBackLoopEnabled) return;
      const connection = await initSocket();
      if (isAuthenticated) {
        connection.connect();
      } else {
        connection.close();
      }
    };
    connectSocket();
  }, [isAuthenticated, isFeedBackLoopEnabled]);

  useEffect(() => {
    const unread = _.uniqBy(
      notifications.filter((n) => n.seen === false),
      'documentNo'
    );
    setUnreadNotification(unread);
  }, [notifications]);

  function viewNotification(notification) {
    dispatch(SocketActions.readNotification(notification.id));
    window.open(`${location.origin}${notification.targetUrl}`, '_blank');
  }

  const notificationBlock = _.uniqBy(notifications, 'documentNo').map((notification) => {
    return (
      <ListGroup.Item
        as="li"
        bsPrefix=" "
        key={notification.id}
        onClick={() => viewNotification(notification)}
      >
        <Link to="#" className="dropdown-item">
          <i className={notification.seen === true ? 'feather icon-inbox' : 'feather icon-mail'} />
          New Feedback request for {notification.documentNo}
        </Link>
      </ListGroup.Item>
    );
  });

  return (
    <React.Fragment>
      {isPopupOpen === true ? (
        <ContactSupport isPopupOpen={isPopupOpen} onPopup={setPopupOpen} />
      ) : null}{' '}
      <ListGroup as="ul" bsPrefix=" " className="navbar-nav ml-auto">
        <ListGroup.Item as="li" bsPrefix=" " className="nav-item">
          <Badge>
            <a href="#!" className="full-screen" onClick={() => toggleFullScreen()}>
              {isFullScreen ? (
                <i className="feather icon-minimize"></i>
              ) : (
                <i className="feather icon-maximize"></i>
              )}
            </a>
          </Badge>
        </ListGroup.Item>
        {isFeedBackLoopEnabled && (
          <ListGroup.Item as="li" bsPrefix=" " className="nav-item">
            <Badge pill variant={isSocketConnected ? 'success' : 'danger'}>
              &nbsp;&nbsp;
            </Badge>
          </ListGroup.Item>
        )}
        {notifications.length > 0 && (
          <Badge>
            <ListGroup.Item as="li" bsPrefix=" ">
              <Dropdown alignRight={!rtlLayout} className="drp-user">
                <Dropdown.Toggle as={Link} variant="link" to="#" id="dropdown-basic">
                  <i className="feather icon-bell"></i>
                  {unreadNotification.length > 0 ? (
                    <span
                      className="badge badge-danger px-1"
                      style={{
                        borderRadius: '100px',
                        right: '-5px',
                        position: 'absolute',
                        top: '6px',
                        padding: '4px'
                      }}
                    >
                      {unreadNotification.length}
                    </span>
                  ) : (
                    <></>
                  )}
                </Dropdown.Toggle>
                <Dropdown.Menu alignRight className="profile-notification">
                  <ListGroup
                    as="ul"
                    bsPrefix=" "
                    variant="flush"
                    className="pro-body"
                    style={{ maxHeight: '35vh', overflowY: 'auto' }}
                  >
                    {notificationBlock}
                  </ListGroup>
                </Dropdown.Menu>
              </Dropdown>
            </ListGroup.Item>
          </Badge>
        )}
        <ListGroup.Item as="li" bsPrefix=" ">
          <Badge>
            <Dropdown alignRight={!rtlLayout} className="drp-user">
              <Dropdown.Toggle as={Link} variant="link" to="#" id="dropdown-basic">
                <img src={user} className="img-radius wid-40" alt="User Profile" />
              </Dropdown.Toggle>
              <Dropdown.Menu alignRight className="profile-notification">
                <div className="pro-head">
                  <span>{username}</span>
                </div>
                <ListGroup as="ul" bsPrefix=" " variant="flush" className="pro-body">
                  <ListGroup.Item as="li" bsPrefix=" ">
                    <Link to="/settings/change-password" className="dropdown-item">
                      <i className="feather icon-lock" /> Change Password
                    </Link>
                  </ListGroup.Item>
                  <ListGroup.Item as="li" bsPrefix=" ">
                    <Link to="#" className="dropdown-item" onClick={() => popupOpen()}>
                      <i className="feather icon-mail" /> Contact Support
                    </Link>
                  </ListGroup.Item>
                  <ListGroup.Item as="li" bsPrefix=" ">
                    <Link to="#" className="dropdown-item" onClick={() => handleLogout()}>
                      <i className="feather icon-log-out" /> Logout
                    </Link>
                  </ListGroup.Item>
                </ListGroup>
              </Dropdown.Menu>
            </Dropdown>
          </Badge>
        </ListGroup.Item>
      </ListGroup>
    </React.Fragment>
  );
};

export default NavRight;
